import { PIT_COLS, PIT_PASS, PIT_ROWS, PAWN, TYPE_MASK, WHITE, escapeSquares, isAction, moveFrom, movePromo, moveTo, pitCells, pitPhase, squareName } from '@chessbut/engine';
import type { VariantUi } from './ui.ts';

const PIT = '/art/pit.svg';
const escaped = (rec: { events: { t: string; kind?: string }[] }) => rec.events.some((e) => e.t === 'fx' && e.kind === 'escape');

export const comebackUi: VariantUi = {
  heroImage: PIT,
  peek: [{}, { image: '/art/bQ.svg' }, {}, {}, { image: PIT }, {}, {}, { image: '/art/wN.svg', threat: true }, {}],

  actions(_pos, legal) {
    const pass = legal.find((m) => isAction(m) && movePromo(m) === PIT_PASS);
    return pass === undefined ? [] : [{ label: 'Pass (Pit)', move: pass, title: 'Make no move in the Pit this turn' }];
  },

  sideBoard(pos) {
    const cells = pitCells(pos);
    const n = cells.reduce((a, p) => a + (p ? 1 : 0), 0);
    return {
      title: 'The Pit',
      hint: pitPhase(pos) ? 'Your Pit move: capture to escape, or pass' : n ? 'Capture down here to escape back to the board' : 'Captured pieces land here',
      cols: PIT_COLS,
      rows: PIT_ROWS,
      cells,
      cellOf: (v) => (v >= 0 && v < PIT_COLS * PIT_ROWS ? v : -1),
      isMove: (m) => isAction(m) && movePromo(m) !== PIT_PASS,
      optionLabel(m) {
        const from = moveFrom(m);
        const to = moveTo(m);
        const piece = cells[from];
        const promoted = (piece & TYPE_MASK) === PAWN && Math.floor(to / PIT_COLS) === (pos.turn === WHITE ? PIT_ROWS - 1 : 0);
        const sq = escapeSquares(pos.board, pos.turn, piece & TYPE_MASK, promoted)[movePromo(m) - 1];
        return `Back on ${squareName(sq)}`;
      },
      active: pitPhase(pos),
    };
  },

  twist(pos, you) {
    const mine = you === null || pos.turn === you;
    if (pitPhase(pos)) return mine ? { text: 'Now your Pit move: capture to escape, or pass.', alert: false } : { text: 'They’re fighting in the Pit…' };
    return { text: 'Captured pieces drop into the Pit. Win a fight there to come back.' };
  },

  eventSound(e) {
    if (e.t !== 'fx') return null;
    return e.kind === 'escape' ? 'rise' : e.kind === 'pit' ? 'rumble' : null;
  },

  moveBadge(rec) {
    return escaped(rec) ? { icon: PIT, title: 'Escaped the Pit' } : null;
  },
};
